import {
  whiteColor,
  oceanBlueColor,
  DodgerBlueColor,
} from "../../cmsMainStyle";

const pasStyle = (theme) => ({
  itemRoot: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  itemText: {
    display: "inline",
  },

  appbarTest: {
    color: oceanBlueColor[9],
    fontStyle: "italic",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
});

export { pasStyle };
